module.exports = __webpack_public_path__ + "media/images/curve1-fcf2a09983fc285e65a25339530a9d8e.png";